import React, {Component} from 'react';
import { Field, FormSection } from 'redux-form';

import Countries from '../data/countries';
import CountryStates from '../data/states';

const renderField = ({ input, className, label, type, meta: { touched, error } }) => (
  	<div className={className}>
		<input {...input} placeholder={label} type={type} />
	</div>
)

const renderCountrySelector = ({ input, countries, meta: { touched, error } }) => (
  <div className="small-12 medium-6 column">
    <select {...input}>
      {countries.map((val,index) => (
        <option value={val.code} key={index}>
          {val.name}
        </option>
      ))}
    </select>
  </div>
)

const renderStateSelector = ({ input, states, meta: { touched, error } }) => (
  <div className="small-12 medium-6 column">
    <select {...input}>
      {states.map((val,index) => (
        <option value={val.id} key={index}>
          {val.name}
        </option>
      ))}
    </select>
  </div>
)

class NewAgency extends Component {
	constructor(props) {
		super(props)
		this.state = {
			countries: Countries,
			countryStates: CountryStates.filter(states => states.countryCode === 'US')
		}

		this.onChangeCountry = countryCode => {
			this.setState({
				'countryStates': CountryStates.filter(states => states.countryCode === countryCode) 
			})
		}
	}

	render() {
		const { countries, countryStates } = this.state
		return (
		<div className="row small-12 medium-8 column">
			<FormSection name="agency">
			<div className="row">
				<Field 
					className="small-12 column"
					name="name" 
					component={renderField} 
					type="text" 
					label="Company name"/>
			</div>

			<div className="row">
				<Field 
					className="small-12 medium-6 column"
					name="agent_first_name" 
					component={renderField} 
					type="text" 
					label="Company first name"/>

				<Field 
					className="small-12 medium-6 column"
					name="agent_last_name" 
					component={renderField} 
					type="text" 
					label="Company last name"/>
			</div>

			<div className="row">
				<Field 
					className="small-12 column"
					name="agent_email_address" 
					component={renderField} 
					type="text" 
					label="Email address"/>
			</div>

			<div className="row">
				<Field 
					className="small-12 column"
					name="agent_contact_number" 
					component={renderField} 
					type="text" 
					label="Company phone"/>
			</div>

			<div className="row">
				<Field 
		  			name="country" 
		  			onChange={(event) => this.onChangeCountry(event.target.value)}
		  			component={renderCountrySelector} 
		  			countries={countries} />
		  		<Field 
		  			name="state" 
		  			component={renderStateSelector} 
		  			states={countryStates} />
			</div>

			<div className="row">
				<div className="small-12 column">
					<div className="custom-checkbox">
            <Field
              className="styled-checkbox"
              name="confirmPresented"
              id="confirm_presented"
              component="input"
              type="checkbox"
            />
            <label htmlFor="confirm_presented">I confirm I am presented by this company</label>
          </div>
				</div>
			</div>
			</FormSection>
		</div>
		)
	}
}

export default NewAgency


// WEBPACK FOOTER //
// ./src/components/NewAgency.js